import { useState } from 'react';
import { AutoComplete, Input, Typography, Space, Button } from 'antd';
import { SearchOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useRecentSearches } from '../../hooks/useLocalStorage';

const { Text } = Typography;

interface TraceSearchInputProps {
  onSearch?: (query: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

export function TraceSearchInput({
  onSearch,
  placeholder = 'Search trace/job/span ID...',
  style,
}: TraceSearchInputProps) {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const { searches, addSearch, clearSearches } = useRecentSearches();

  const handleSearch = (searchValue: string) => {
    const trimmed = searchValue.trim();
    if (!trimmed) return;

    addSearch(trimmed);

    if (onSearch) {
      onSearch(trimmed);
    } else {
      navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    }
  };

  const options = searches.length > 0
    ? [
        {
          label: (
            <Space style={{ justifyContent: 'space-between', width: '100%' }}>
              <Text type="secondary">
                <ClockCircleOutlined /> Recent Searches
              </Text>
              <Button
                type="link"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  clearSearches();
                }}
                icon={<CloseOutlined />}
              >
                Clear
              </Button>
            </Space>
          ),
          options: searches.map((search) => ({
            value: search,
            label: search,
          })),
        },
      ]
    : [];

  return (
    <AutoComplete
      value={value}
      onChange={setValue}
      onSelect={handleSearch}
      options={options}
      style={{ width: 300, ...style }}
      popupMatchSelectWidth={300}
    >
      <Input.Search
        placeholder={placeholder}
        prefix={<SearchOutlined />}
        allowClear
        onSearch={handleSearch}
        enterButton
      />
    </AutoComplete>
  );
}
